<template>
  <section
    v-if="reviewsCount"
    id="customerReviews"
    :class="currentReviewsCount ? 'space-y-8 ' : 'pt-4'"
    data-scroll-el="customerReviews"
    data-test-id="customer-reviews"
  >
    <div class="space-y-6 ">
      <template v-if="reviewsPending">
        <product-reviews-skeleton v-for="key in pageSize" :key />
      </template>
      <product-reviews-item
        v-else
        v-for="review in reviews"
        :key="review.reviewId"
        :product-id="productId"
        :review="review"
        :search-term="searchTerm"
      />
    </div>
    <div class="f-col center md:flex-row md:between" :class="{ 'gap-1': pagesCount > 1 }">
      <div class="f-col center gap-2 md:flex-row md:gap-4">
        <p
          :class="currentReviewsCount ? 'c-grey-20' : 'text-base'"
          data-test-id="display-reviews"
          role="status"
        >
          {{ currentReviewsDisplayed }}
        </p>
        <base-button
          v-if="currentReviewsCount"
          class="underlined"
          data-test-id="reviews-back-to-top"
          @click="scrollToCustomerReviews"
        >
          {{ $t.backToTop }}
        </base-button>
      </div>
      <div class="flex">
        <base-button
          v-if="currentPageNumber > 1"
          class="underlined"
          @click="$emit('previous')"
        >
          {{ $t.previous }}
        </base-button>
        <span v-if="currentPageNumber > 1 && currentPageNumber < pagesCount" class="mx-2">|</span>
        <base-button
          v-if="pagesCount && currentPageNumber < pagesCount"
          class="underlined"
          data-test-id="reviews-next"
          @click="$emit('next')"
        >
          {{ $t.next }}
        </base-button>
      </div>
    </div>
  </section>
  <div v-else class="text-center">
    <vf-button class="<md:w-full" :variant @click="$emit('write-review')">
      {{ $t.writeFirstReview }}
    </vf-button>
  </div>
</template>

<script lang="ts" setup>
import type { ButtonVariant } from '#types/components/vf/button'
import type { ProductReviewsReview } from '#root/api/clients/product/data-contracts'

defineProps<{
  reviewsCount: number
  currentReviewsCount: number
  reviews: ProductReviewsReview[]
  reviewsPending: boolean
  pageSize: number
  productId: string
  searchTerm?: string
  pagesCount: number
  currentPageNumber: number
  currentReviewsDisplayed: string
  variant?: ButtonVariant
}>()

defineEmits<{
  'next': []
  'previous': []
  'write-review': []
}>()

const { $t } = useNuxtApp()

const scrollToCustomerReviews = () => scrollToElement('customerReviews')
</script>
